import services from '@/http'
//import * as storage from '../storage'
import * as types from './mutation-types'
import * as storage from '../storage'


export const ActionGetCategorias = ({ commit }) => {
  return services.product_car_list.getCategoriesProdutos().then(res => {
    commit(types.SET_CATEGORIES_PRODUTOS, res.data.results)
  })
  
}
export const ActionGetProductByCategorias = (context,{car,categorie}) => {
  return services.product_car_list.getProdutosByCategories({car:car,categorie:categorie}).then(res => {
    sessionStorage.setItem('product_search', JSON.stringify(res.data.results) )
    context.commit(types.SET_PRODUTOS_BY_CATEGORIE, res.data.results)
    context.commit(types.SET_QUANTITY_PRODUTOS_BY_CATEGORIE, res.data.count)
  })
  
}

export const ActionGetProductByCar = (context,{car}) => {
  return services.product_car_list.getProdutosByCar({car:car}).then(res => {
    context.commit(types.SET_ALL_PRODUCTS, res.data.results)
  })

  
}

export const ActionDeleteGarage = (context,{id}) => {
  const confirmaExclusao = confirm('Deseja excluir esse carro ?')
  if (confirmaExclusao === true){
    return services.product_car_list.deleteGarage({id:id}).then(res => {
      res
      storage.deleteGarageSelected()
      alert('Carro removido com sucesso.')
    })
    .catch(err => {
      console.log('Error', err)
    })
  }

  
}




export const ActionDeleteProductByCategorias = ({commit}) => {
    commit(types.SET_PRODUTOS_BY_CATEGORIE, [])
    commit(types.SET_QUANTITY_PRODUTOS_BY_CATEGORIE, 1)  
}

export const ActionDeleteAllProductByCar = ({commit}) => {
    commit(types.SET_ALL_PRODUCTS, [])
}


export const ActionSetChoicedProduct = (context,payload) => {
    context.commit(types.SET_CHOICED_PRODUCT, payload)
    localStorage.setItem('choiced_product', JSON.stringify(payload))
}

